
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface SidebarItemProps {
  href: string;
  icon: React.ReactNode;
  title: string;
  isActive: boolean;
  onClick?: () => void;
}

export const SidebarItem = React.forwardRef<HTMLDivElement, SidebarItemProps>(({ 
  href, 
  icon, 
  title, 
  isActive, 
  onClick 
}, ref) => {
  if (onClick) {
    return (
      <div ref={ref}>
        <Button
          variant="ghost"
          className={cn(
            "w-full justify-start gap-2",
            isActive ? "bg-sidebar-accent text-sidebar-accent-foreground" : "text-sidebar-foreground hover:bg-sidebar-accent/50 hover:text-sidebar-accent-foreground"
          )}
          onClick={onClick}
        >
          {icon}
          <span>{title}</span>
        </Button>
      </div>
    );
  }

  return (
    <div ref={ref}>
      <Link to={href}>
        <Button
          variant="ghost"
          className={cn(
            "w-full justify-start gap-2",
            isActive ? "bg-sidebar-accent text-sidebar-accent-foreground" : "text-sidebar-foreground hover:bg-sidebar-accent/50 hover:text-sidebar-accent-foreground"
          )}
        >
          {icon}
          <span>{title}</span>
        </Button>
      </Link>
    </div>
  );
});

SidebarItem.displayName = "SidebarItem";
